export enum ScenarioType {
  SCENARIO_1 = 1,
  SCENARIO_2 = 2,
  SCENARIO_3 = 3,
  SCENARIO_4 = 4,
  SCENARIO_EXPERIAN = 'SCENARIO_EXPERIAN',
}
